import { useMutation } from "@tanstack/react-query";

import { getAuth, isProfileAuth } from "~/providers/store/auth/getters";
import { DisplayError, DisplayErrorCodeEnum } from "~/utils/display-error";

import { useCurrentTill } from "../../tills/hooks/use-till-current";
import { createOrderSimple, type CreateOrderSimpleArgs } from "../requests";

type UseCreateOrderSimpleArgs =
  | {
      authenticationMethod: "cardHex";
      authenticationCode: CreateOrderSimpleArgs["cardHex"];
    }
  | {
      authenticationMethod: "qrCode";
      authenticationCode: CreateOrderSimpleArgs["qrCode"];
    };

export function useCreateOrderSimple() {
  const { data: till } = useCurrentTill();
  const sessionId = till?.sessionId;

  return useMutation({
    mutationFn: ({
      authenticationMethod,
      authenticationCode
    }: UseCreateOrderSimpleArgs) => {
      const auth = getAuth();

      if (!isProfileAuth(auth)) {
        throw new DisplayError(DisplayErrorCodeEnum.PROFILE_NOT_SELECTED);
      }

      if (!sessionId) {
        throw new DisplayError(DisplayErrorCodeEnum.SESSION_NOT_ACTIVE);
      }

      return createOrderSimple({
        tillId: auth.tillId,
        [authenticationMethod]: authenticationCode,
        profileId: auth.profileId
      });
    }
  });
}
